module.exports = __webpack_public_path__ + "static/media/Elf1.453d54be.png";